import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.9.3@antd/es/form/index.js
// module id = 631
// module chunks = 0